export const iconFontAwesomeFilmVideoMicrophoneSlash = (
	<i className="fa-solid fa-microphone-slash"></i>
);
